import {ConfirmModal} from "components";
import {Dispatch, SetStateAction} from "react";

interface ModalRefreshExpirationProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const ModalRefreshExpiration = (props: ModalRefreshExpirationProps) => {
  const {isOpen, setIsOpen} = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={"Sessão expirada"}
      titleIcon="exit_to_app"
      subtitle={"Você está sendo desconectado..."}
      confirmButtonFn={handleClose}
      onClose={handleClose}
      color="warning"
      hasOnlyConfirmButton
      confirmButtonText={"Ok"}
      confirmButtonIconStart=""
      dataTestId={"modal-refresh-expiration"}
    />
  );
};

export default ModalRefreshExpiration;
